module.exports = __webpack_public_path__ + "static/images/components/RewardBox/images/rewardBox.da5b2787.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardBox/images/rewardBox.png
// module id = 2664
// module chunks = 11